export enum LiveLearningRoutesConfig {
	LIVE_LEARNING_BASE_URL = 'live-learning'
}

export class LiveLearningRoutes {
	public static readonly LiveLearning = LiveLearningRoutesConfig.LIVE_LEARNING_BASE_URL;
	public static readonly LIVE_LEARNING_HOME_ROUTE = '/' + LiveLearningRoutes.LiveLearning;
}
